import {useTransition} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'

import {Props} from './TrustModal.types'
import {buildKey} from './utils'

export function useTrustModal({fetchBindingUrl}: Props) {
  const t = useI18n()
  const [{payload: bindingUrl, isPending, error}, startTransition] = useTransition(fetchBindingUrl, {
    key: buildKey('binding-url'),
  })
  const translates = {
    repeat: t('phoenix.add_new_card.label', 'Повторить'),
    title: t('phoenix.add_new_card.title'),
    subtitle: t('phoenix.add_new_card.label'),
  } as const

  return {
    isPending,
    bindingUrl,
    error,
    translates,
    updateHandler() {
      startTransition(fetchBindingUrl)
    },
  } as const
}
